import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CostSheetTreeView from '../CostSheetTreeView';

function AddCostSheetMappingModal({
  open,
  onClose,
  projectLinkedCostSheets = [],
  costSheetCategories = [],
  existingMappingIds = [],
  onConfirm,
}) {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  const [selectedLinkedId, setSelectedLinkedId] = useState('');
  const [selectedTreeId, setSelectedTreeId] = useState(null);

  const availableLinked = projectLinkedCostSheets.filter(
    (sheet) => !existingMappingIds.includes(sheet.id)
  );

  const handleClose = () => {
    setTab(0);
    setSelectedLinkedId('');
    setSelectedTreeId(null);
    onClose();
  };

  const handleConfirm = () => {
    const costSheetId = tab === 0 ? parseInt(selectedLinkedId, 10) : selectedTreeId;
    if (!Number.isFinite(costSheetId)) return;
    onConfirm(costSheetId);
    handleClose();
  };

  const canConfirm = tab === 0
    ? Number.isFinite(parseInt(selectedLinkedId, 10))
    : Number.isFinite(selectedTreeId);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('dailyWorkCostSheetMapping.addCostSheet')}</DialogTitle>
      <DialogContent dividers>
        <Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ mb: 2 }}>
          <Tab label={t('dailyWorkCostSheetMapping.modal.tabLinked')} />
          <Tab label={t('dailyWorkCostSheetMapping.modal.tabAll')} />
        </Tabs>

        {tab === 0 && (
          <Box>
            {availableLinked.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                {t('dailyWorkCostSheetMapping.modal.noLinkedCostSheets')}
              </Typography>
            ) : (
              <FormControl fullWidth>
                <InputLabel id="linked-cost-sheet-label">
                  {t('dailyWorkCostSheetMapping.modal.selectCostSheet')}
                </InputLabel>
                <Select
                  labelId="linked-cost-sheet-label"
                  value={selectedLinkedId}
                  label={t('dailyWorkCostSheetMapping.modal.selectCostSheet')}
                  onChange={(e) => setSelectedLinkedId(e.target.value)}
                >
                  {availableLinked.map((sheet) => (
                    <MenuItem key={sheet.id} value={sheet.id}>
                      {[sheet.code, sheet.name].filter(Boolean).join(' — ')}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Box>
        )}

        {tab === 1 && (
          <Box sx={{ maxHeight: 420, overflow: 'auto' }}>
            <CostSheetTreeView
              categories={costSheetCategories}
              selectedCostSheetId={selectedTreeId}
              onCostSheetSelect={(sheet) => {
                if (existingMappingIds.includes(sheet.id)) return;
                setSelectedTreeId(sheet.id);
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('common.cancel')}</Button>
        <Button variant="contained" onClick={handleConfirm} disabled={!canConfirm}>
          {t('dailyWorkCostSheetMapping.modal.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddCostSheetMappingModal;
